import '@fontsource-variable/inter/wght.css';
import '@fontsource-variable/inter/wght-italic.css';
import { SpriteProvider } from '@frontends/ds-icons';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import './assets/styles/app.css';
import './i18n';

createRoot(document.getElementById('root') as HTMLElement).render(
  <SpriteProvider>
    <App />
  </SpriteProvider>,
);
